import React from "react";
import { MdReply } from "react-icons/md";
import styles from "./DocumentViewer.module.scss";

const EmailToolbar = ({ onReply, onForward, disabled = false }) => {
  return (
    <div
      className={`d-flex align-items-center justify-content-end flex-shrink-0 gap-2 ${styles["email-toolbar"]}`}
      role="toolbar"
      aria-label="Email actions">
      <button
        type="button"
        className="secondary-action-btn"
        disabled={disabled}
        onClick={onReply}
        aria-label="Reply">
        <MdReply size={18} aria-hidden />
        <span>Reply</span>
      </button>
      <button
        type="button"
        className="secondary-action-btn"
        disabled={disabled}
        onClick={onForward}
        aria-label="Forward">
        <MdReply
          size={18}
          aria-hidden
          style={{ transform: "scaleX(-1)" }}
        />
        <span>Forward</span>
      </button>
    </div>
  );
};

export default EmailToolbar;
